import { ArrowLeft } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Button } from "@/components/ui/button";

// Detalle de un carrito Holanda embebido DENTRO de AROC (iframe kiosk a Grafana),
// para no sacar al operador del portal. Recibe gid/ch/site por query y arma la
// URL del dashboard `emporia-carrito`. "Regresar" vuelve a la alarma de origen.
export function HolandaCarritoTableroPage() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const gid = sp.get("gid") ?? "";
  const ch = sp.get("ch") ?? "";
  // `site` es el nombre de Emporia (con él filtra Grafana); `nombre` es el
  // homologado, sólo para el título.
  const site = sp.get("site") ?? "";
  const nombre = sp.get("nombre") || site;

  const qs = new URLSearchParams();
  if (gid) qs.set("var-gid", gid);
  if (ch) qs.set("var-ch", ch);
  if (site) qs.set("var-site", site);
  // kiosk: oculta el chrome de Grafana (AROC ya pone el botón Regresar).
  const url = `/grafana/d/emporia-carrito?${qs.toString()}&kiosk`;

  const titulo =
    [nombre, ch && `POS ${ch}`].filter(Boolean).join(" · ") || "Carrito";

  return (
    <div className="flex h-full flex-col gap-3">
      <div className="flex items-center gap-3">
        <Button size="sm" variant="outline" onClick={() => navigate(-1)}>
          <ArrowLeft className="mr-1 size-4" /> Regresar
        </Button>
        <h1 className="truncate text-lg font-semibold tracking-tight">
          🍦 Detalle de carrito — {titulo}
        </h1>
      </div>
      <iframe
        src={url}
        title="Detalle de carrito"
        className="block w-full flex-1 rounded-md border"
        allow="fullscreen"
      />
    </div>
  );
}
